import React from 'react';
import { connect } from 'react-redux'
import { NAME as SCHULTEMIX_NAME } from '../reducer'
import { bindActionCreators } from 'redux'
import { actions as schulteMixContainerActions } from '../actions'
import SchulteMixImg from "../../../assets/exerciseIcons/schulte-mix.svg";
import { CSSTransition } from "react-transition-group";
import Timer from "../../Timer/container/Timer"
import ProgressInfo from "../../../components/ProgressInfo";
import GameOver from "../../../components/GameOver";
import { strings } from "../../../constants/strings";
import Grid from "./Grid"
import CountDown from "../../../components/CountDown";
import { getAlphabetForSchulteLetters } from "../../../helpers/alphabetProvider"
import { analyticsActions } from "constants/analytics-actions-id";

import StartOverlay from "components/StartOverlay";

const lang = document.documentElement.lang.slice(0, 2);
const INFINITY = 2000000000

function mapStateToProps(state) {
  return {
    ...state[SCHULTEMIX_NAME]
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...schulteMixContainerActions,
  dispatch
}, dispatch)

class schulteMix extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startOverlayTransitionIsFinished: false,
      progressInfoTransitionIsFinished: false
    }
    props.setType({
      exersizeName: "SCHULTEMIX_",
      getMatix: (size) => {
        let mix = []
        let letters = getAlphabetForSchulteLetters(lang).slice(0, size).split('')
        for(let i = 0;i<size/2;i++) {
          mix.push(i+1)
          if(size-1 !== i*2)
          mix.push(letters[i])
        }
        return mix
      }
    },{ //lvl info
      START: {
        pointsPerClick: 1 * 1.4, //1 in Phone
        size: 4,
        leftToUp: 3,
        defaultLeftToUp: 3, 
        clickToFail: INFINITY,
        defaultClickToFail: INFINITY,
        leftToDown: INFINITY,
        defaultLeftToDown: INFINITY
      },
      SMALL: {
        pointsPerClick: 1.5 * 1.4, //1.6 in Phone
        size: 5,              //Matrix size
        leftToUp: 3,
        defaultLeftToUp: 3,          
        clickToFail: 3,
        defaultClickToFail: 3,
        leftToDown: 2,
        defaultLeftToDown: 2
      },
      MEDIUM: {
        pointsPerClick: 3.5 * 1.4, //3.5 in Phone
        size: 6,
        leftToUp: 2,
        defaultLeftToUp: 2,
        clickToFail: 4,
        defaultClickToFail: 4,
        leftToDown: 1,
        defaultLeftToDown: 1
      },
      BIG: {
        pointsPerClick: 4 * 1.4, //4 in Phone
        size: 7,
        leftToUp: INFINITY,
        defaultLeftToUp: INFINITY,
        clickToFail: 5,
        defaultClickToFail: 5,
        leftToDown: 1,
        defaultLeftToDown: 1
      }
    })
  }

  componentWillUnmount() {
    
  }

  render() {
    if (this.props.exersizeState === 'gameOver') {
      this.timer = setTimeout(() => {
        this.props.dispatch({ type: "SHOW_GAME_OVER_SCREAN" });
      }, 1200);
    }
    return (
      <div className='App exercise-container'>
        <CSSTransition
          in={this.props.exersizeState === 'startScrean'}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited = {()=>this.setState({startOverlayTransitionIsFinished: true})}
        >
          <StartOverlay
            img={SchulteMixImg}
            name={strings.SchulteMix_name}
            title={strings.SchulteMix_title}
            description={strings.SchulteMix_description}
            btnText={strings.OverlayView_btn_start}
            btnId={analyticsActions.SchulteMix.btnStart}
            onClick={() => { this.props.startPreExersize() }}
          />
        </CSSTransition>
        <CSSTransition
          in={this.props.exersizeState === 'scoreScrean' && this.state.progressInfoTransitionIsFinished}
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
        >
          <GameOver
            title = {strings.SchulteMix_name}
            points = {this.props.points}
            countDown = {this.props.countDown}
            exersizeState = {this.props.exersizeState}
            lettersMatrix = {this.props.lettersMatrix}
            analyticsActions={analyticsActions.SchulteMix}
          />
        </CSSTransition>
        <CSSTransition
          in={
            (
            this.props.exersizeState === 'preexersize' || 
            this.props.exersizeState === 'gameStarted' || 
            this.props.exersizeState === 'gameOver'
            ) && this.state.startOverlayTransitionIsFinished
          }
          classNames="swipe"
          timeout={200}
          mountOnEnter
          unmountOnExit
          onExited = {()=>this.setState({progressInfoTransitionIsFinished: true})}    
        >   
              
            <ProgressInfo
              timeLeft={this.props.timeLeft}
              points={this.props.points}
              name={strings.SchulteMix_name}
              title={strings.SchulteMix_title}
              game={
                <>
                  <Timer
                    started={this.props.exersizeState === 'preexersize'}
                    increment={this.props.incrementCountDown}
                    interval={1000}
                    incrementCounter={this.props.countDown}
                    timerFinished={this.props.startGame }
                  />
                  <Timer
                    started={this.props.exersizeState === 'gameStarted'}
                    increment={this.props.increment}
                    interval={1000}
                    incrementCounter={this.props.timeLeft}
                    timerFinished={ this.props.gameOverAction }
                  />
                  <CountDown key="countDown" countDown={this.props.countDown} />
                  <Grid
                    exName="letter-search"
                    key="grid"
                    exersizeState={this.props.exersizeState}
                    onCellClick={ this.props.cellClickAction }
                  />
                </>
              }
            >
              <div className="col-md-6 col-sm-6">
                {strings.SLMB_gesucht}{" "}
                <span className="value">
                  {this.props.toFindMatrix[this.props.toFindPosition]}
                </span>
              </div>
            </ProgressInfo>
        </CSSTransition>
      </div>
    );
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(schulteMix)
